import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { logisticApi } from 'redux/services/logistic'
import { DenyLogistic } from 'redux/services/logistic/types'

import { AppButton } from 'components/AppButton'
import { AppModal } from 'components/AppModal'
import { AppSelect } from 'components/AppSelect'

import { LogisticStatus } from 'models/logistic'

import styles from './Deny.module.scss'

interface Props {
  id: number
}
export function DenyLogisticModal({ id }: Props) {
  const [open, setOpen] = useState(false)
  const denyForm = useForm<DenyLogistic>({
    defaultValues: {
      id,
      body: {
        status: LogisticStatus.transferred,
      },
    },
  })
  const { data: branches } = logisticApi.useGetLogisticBranchesQuery()
  const [deny, denyState] = logisticApi.useDenyLogisticMutation()

  function onSubmitUpdateStatus(values: DenyLogistic) {
    deny(values)
      .unwrap()
      .then(() => {
        setOpen(false)
      })
  }

  return (
    <>
      <AppButton variant="red" onClick={() => setOpen(true)}>
        Отказ от доставки
      </AppButton>
      {open && (
        <AppModal onClose={() => setOpen(false)} title="Отказ от доставки" childrenClassName={styles.content}>
          <form
            className={styles.container}
            onSubmit={denyForm.handleSubmit(onSubmitUpdateStatus)}
          >
            {/* <TextField value={LOGISTIC_STATUS_TEXT[status]} disabled /> */}

            <AppSelect
              label="Филиал"
              text={
                branches?.find(b => b.id === denyForm.watch('body.branch'))
                  ?.name || ''
              }
              onChangeValues={values => {
                if (values[0]) {
                  denyForm.setValue('body.branch', Number(values[0]))
                  denyForm.clearErrors('body.branch')
                }
              }}
              list={
                branches?.map(b => ({
                  value: b.id,
                  title: `${b.name} (${b.address})`,
                })) || []
              }
              required
              withError
              error={denyForm.formState.errors.body?.branch}
            />
            <br />

            {/* <TextField
              {...denyForm.register('body.comment', {
                required: 'Обязательное поле',
              })}
              label="Комментарий"
              withError
              error={denyForm.formState.errors.body?.comment?.message}
            /> */}

            <AppButton disabled={denyState.isLoading} type="submit">
              Сохранить
            </AppButton>
          </form>
        </AppModal>
      )}
    </>
  )
}
